import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 70px 116px;

  > h1 {
    border-bottom: 1px solid #96989a;
    padding-bottom: 10px;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-block: 40px;

    > label {
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }
`;

export const DocumentsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

export const CPFWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;

  > span {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    > p {
      margin: 0;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      min-width: fit-content;
    }
  }
`;

export const DocumentsItem = styled.div`
  display: flex;
  /* justify-content: space-between; */
  align-items: center;

  > p {
    padding-right: 10px;
    min-width: fit-content;
    margin: 0;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  > span {
    width: 100%;
    display: flex;
    align-items: center;

    > a {
      display: inline-flex;
      height: 28px;
      padding: 5px 20px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      flex-shrink: 0;
      border-radius: 0px 5px 5px 0px;
      background-color: var(--color-primary);
      color: #fff;
      cursor: pointer;

      &:hover {
        background-color: var(--color-primary-dark);
      }
    }
  }

  .last__child {
    width: auto;
    align-items: flex-start;
  }
`;

export const Input = styled.input`
  width: 100%;
  height: 28px;
  padding: 0.67857143em 1em;
  outline: 0;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.87);
  font-size: 13px;
  font-family: sans-serif;
  font-weight: 400;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 4px;
  -webkit-appearance: none;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color 0.1s ease, border-color 0.1s ease;
`;

export const UploadWrapper = styled.div`
  margin-top: 20px;
  padding-top: 30px;
  border-top: 1px solid #96989a;

  > h2 {
    margin: 0 0 6px;
  }

  > p {
    margin: 0 0 20px;
    font-size: 14px;
    color: #4a4a4a;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-width: 560px;
    margin-block: 0;
  }
`;

export const Select = styled.select`
  height: 32px;
  padding: 0 1em;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.87);
  font-size: 13px;
  font-family: sans-serif;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 4px;
`;

export const Button = styled.button`
  align-self: flex-start;
  margin-top: 10px;
  height: 32px;
  padding: 0 24px;
  border: 0;
  border-radius: 5px;
  background-color: var(--color-primary);
  color: #fff;
  cursor: pointer;

  &:hover:not(:disabled) {
    background-color: var(--color-primary-dark);
  }

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;
